import { ltrimSlash, rtrimSlash } from "./utils";

export class UrlFactory {
    private readonly baseUrl: string;

    public constructor(baseUrl: string) {
        this.baseUrl = rtrimSlash(baseUrl);
    }

    public create(path: string): string {
        return rtrimSlash(`${this.baseUrl}/${ltrimSlash(path)}`);
    }

    public to(prefix: string): UrlFactory {
        return new UrlFactory(`${this.baseUrl}/${ltrimSlash(prefix)}`);
    }
}
